import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex px-2"
};
const _hoisted_2 = {
  class: "text-gray-700 pl-2"
};
const _hoisted_3 = {
  class: "pl-2"
};
export default {
  __name: 'AttachmentItem',
  props: {
    label: {
      type: String,
      required: true
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, [_createVNode(_component_v_icon, {
        size: "large"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("mdi-attachment", -1)]))]),
        _: 1
      })]), _createElementVNode("span", _hoisted_3, _toDisplayString(__props.label), 1)]);
    };
  }
};